import { render, staticRenderFns } from "./ApprovalPingfenTaskReport.vue?vue&type=template&id=a2881c78&scoped=true"
import script from "./ApprovalPingfenTaskReport.vue?vue&type=script&lang=js"
export * from "./ApprovalPingfenTaskReport.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPingfenTaskReport.vue?vue&type=style&index=0&id=a2881c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2881c78",
  null
  
)

export default component.exports